import AbsModule from "../common/AbsModule";
import PurpleUserInfo from "./PurpleUserInfo";
import { lnbMarkup } from '../common/LnbCommon';

class PurplePanel extends AbsModule {
    constructor(config) {
        super(config);
        
        this.purpleUserInfo = new PurpleUserInfo(config);
        this.iScroll = null;
    }

    startSetting() {
        this.purpleUserInfo.startSetting({
            parentType: PurpleUserInfo.PARENT_TYPE_PANEL,
            parent: document.querySelector('.ncc-purple-panel-wrap')
        });
    }

    createIScroll() {
        if (this.iScroll) return;
        const isMo = this.com?.isMobile;
        this.iScroll = new IScroll('.ncc-purple-panel-wrap', {
            scrollbars: true,
            mouseWheel: true,
            interactiveScrollbars: true,
            shrinkScrollbars: 'scale',
            disableMouse: !isMo,
            disablePointer: !isMo,
            fadeScrollbars: true,
            // preventDefault: true,
            preventDefaultException: {
                tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|A|LI|SPAN|IMG|STRONG)$/
            },
        });
    }

    show() {
        const purplePanel = document.querySelector('.ncc-purple-panel');
        purplePanel?.classList?.add('is-active');
        this.dim.openClose(true, 'purple');
        this.createIScroll();
    }

    hide() {
        const purplePanel = document.querySelector('.ncc-purple-panel');
        purplePanel?.classList?.remove('is-active');
        this.dim.openClose(false);
    }

    destroy() {
        if (this.iScroll) {
            this.iScroll.destroy();
            this.iScroll = null;
        }
    }

    makeMarkup() {
        const { lnbData, active } = this.moduleData || {};

        return `<div class="ncc-purple-panel">
            <div class="ncc-purple-panel-wrap">
                <div class="ncc-purple-panel-content">
                    <div class="ncc-purple-userinfo">
                        <div class="ncc-purple-userinfo-wrap">
                            ${this.purpleUserInfo.markUp}
                        </div>
                    </div>
                    <div class="ncc-purple-lnb">
                        ${lnbMarkup({
                            lnbData, 
                            isSub: false, 
                            active
                        })}
                    </div>
                </div>
            </div>
        </div>`;
    }
}

export default PurplePanel;